import {DateTime} from 'luxon';

import formatDate from './date';

export default function (value, locale, timezone) {
    return formatDate(value, DateTime.DATETIME_MED, locale, timezone);
}
